import { useMutation } from '@tanstack/react-query'
import qs from 'query-string'

import axios from '@pepper/utils/src/function/axios/editorInstance'
import extract from '@pepper/utils/src/function/extract'

interface Parameter {
  companyId?: string
  isPublic?: boolean
  body: {
    data: { id: string; item_type: 'assignment' | 'private_doc' }[]
    export_purpose?: { purpose: string; message?: string }[]
  }
}

type Response = {
  id: string
}

export async function bulkDownload({ companyId, isPublic, body }: Parameter) {
  const url = qs.stringifyUrl({
    url: `/editor/bulk-export`,
    query: {
      company_id: companyId,
      is_public: isPublic
    }
  })
  try {
    const response = await axios.post(url, body)
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function usePostBulkDocsDownload() {
  return useMutation({
    mutationKey: ['bulk-export'],
    mutationFn: bulkDownload
  })
}
